/**
 * FTUE persistence service (PEL-515).
 *
 * Writes completed onboarding steps to the account-level `ftue_state`. The
 * server union-merges `completedSteps` (monotonic), so sending only the newly
 * completed ids is safe under concurrent tabs/devices. Returns the updated
 * user (also surfaced by /me) so callers can refresh the cache.
 */

import apiClient from '@/lib/api-client'
import type { User } from '@/types'
import { FTUE_VERSION } from './types'

export interface FtueStateUpdatePayload {
  version: number
  completedSteps: string[]
  completedAt?: string | null
}

export const ftueService = {
  async updateFtueState(completedSteps: string[]): Promise<User> {
    const payload: FtueStateUpdatePayload = { version: FTUE_VERSION, completedSteps }
    const response = await apiClient.patch<User>('/api/v1/users/me/ftue-state', payload)
    return response.data
  },
}
